import React, { useState } from 'react';
import LoginForm from './admin/LoginForm';

const AdminButton = ({ onAdminAccess }) => {
  const [showLogin, setShowLogin] = useState(false);

  return (
    <>
      <button
        onClick={() => setShowLogin(true)}
        className="px-4 py-2 bg-gray-800 text-white rounded-lg hover:bg-gray-700 transition-colors"
      >
        Acceso Admin
      </button>

      {showLogin && (
        <LoginForm
          onLogin={(user) => {
            // forward user info if needed
            onAdminAccess && onAdminAccess(user);
            setShowLogin(false);
          }}
          onCancel={() => setShowLogin(false)}
        />
      )}
    </>
  );
};

export default AdminButton;

// DONE